import type { ReactNode } from 'react';

export function SectionHeading({ children }: { children: ReactNode }) {
   return <h2 className="heading-30 max-sm:text-left">{children}</h2>;
}
